import { type MRT_TableOptions } from "material-react-table";

import { useMemo } from "react";

import { ConfigurationTableRow } from "@plansoft-configuration-renderer/configuration-api";

import {
  TableControlLayoutProps,
  TableControlOtherOptions,
  TableControlUiOptions,
} from "./TableControlLayoutProps";
import { extractAndMergeOptions } from "./utils/extractAndMergeOptions";

export const TABLE_CONTROL_UI_OPTIONS_DEFAULTS: Required<TableControlUiOptions> =
  {
    enableClickToCopy: false,
    enableMultiSort: true,
    enableFullScreenToggle: false, // leads to problems with overlapping UI
    enableGlobalFilter: false, // not supported by server API,
    enableColumnFilters: true,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableSorting: true,
    layoutMode: "semantic",
  };

export const TABLE_CONTROL_OTHER_OPTIONS_DEFAULTS: Required<TableControlOtherOptions> =
  {
    pageSizeOptions: [5, 10, 25, 50, 100, 250, 500],
  };

/**
 * Extract UI options and assign default values to them
 * @param options
 * @returns
 */
export function useTableControlUiOptions(
  options: TableControlLayoutProps,
): Required<TableControlUiOptions> {
  // override the default values with the provided options
  return useMemo(
    () => extractAndMergeOptions(options, TABLE_CONTROL_UI_OPTIONS_DEFAULTS),
    [options],
  );
}

export function useTableControlOtherOptions(
  options: TableControlLayoutProps,
): Partial<MRT_TableOptions<ConfigurationTableRow>> {
  return useMemo(() => {
    const mergedOptions = extractAndMergeOptions(
      options,
      TABLE_CONTROL_OTHER_OPTIONS_DEFAULTS,
    );
    return {
      // placeholder for other options
      muiPaginationProps: {
        rowsPerPageOptions: mergedOptions.pageSizeOptions,
      },
      muiToolbarAlertBannerProps: {
        sx: {
          "& .MuiButton-textPrimary": {
            color: "info.contrastText",
          },
        },
      },
    };
  }, [options]);
}
